import { Children } from "./children.model";

export class CardInfo {
   /*
   *
   */
    constructor(
      public id?:  number,
      public displaySorting?: number,
      public visible?: boolean,
      public active?: boolean,
      public creationDate?: Date,
      public updateDate?: Date,
      public parentIdCard?: number,
      public photo?: string,
      public title?: string,
      public type?: string,
      public children?: Children[]
    ){}
    
}